import { FormControl, Select, MenuItem, InputLabel, TextField, FormControlLabel, Switch, IconButton } from "@mui/material";
import { Grid } from "@mui/system";
import styles from "../css/Reacciones.module.css";
import { useEffect, useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SyncIcon from '@mui/icons-material/Sync';

import miAxios from "../api/axios";
import { useAuth } from "../hooks/AuthProvider";
import Viewer from "../components/Viewer";
import Wait from "../components/Wait";

const getHoy = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-' + mm + '-' + dd;
    return today;
}
const getFechaInicio = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-01-01';
    return today;
}

export default function Reacciones(props) {
    const [proceso, setProceso] = useState(1)
    const [desde, setDesde] = useState(getFechaInicio())
    const [hasta, setHasta] = useState(getHoy())
    const [sinResponder, setSinResponder] = useState(true)
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [rows, setRows] = useState([])
    const [openViewer, setOpenViewer] = useState({ open: false, id: 0, tipo: 1 })

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        actRows()
    }, [desde, hasta, proceso, sinResponder])

    const actRows = async () => {
        if (desde == null || hasta == null || desde.length == 0 || hasta.length == 0)
            setProcesando(true)
        try {
            const response = await axios.post("reacciones/listado", {
                sin_responder: sinResponder,
                desde: desde,
                hasta: hasta,
                proceso: proceso
            })
            const data = response.data;
            if (data.respuesta == "S") {
                setRows(data.lista)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleRespondido = async (cual, valor) => {
        const n = rows.map((row) => {
            if (row.id == cual) {
                return {
                    ...row,
                    respondido: valor
                }
            } else {
                return row
            }
        })
        setRows(n)
        await actRespondido(cual, valor)
    }

    const actRespondido = async (cual, valor) => {
        setProcesando(true)
        try {
            const response = await axios.post("reacciones/respondido?mensaje=" + cual + "&respondido=" + valor)
            const data = response.data;
            console.log(data)
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    return <div className={styles.cuerpo}>
        <Wait procesando={procesando} />
        <Viewer
            open={openViewer.open}
            id={openViewer.id}
            tipo={openViewer.tipo}
            cerrar={() => { setOpenViewer({ open: false, id: 0, tipo: 0 }) }}
        />
        <div className={styles.titulo}>
            Reacciones Socios
        </div>
        <div className={styles.filtro}>
            <div className={styles.bt_act}>
                <IconButton size="small" color="coopinfa" onClick={() => { actRows() }}>
                    <SyncIcon />
                </IconButton>
            </div>
            <Grid container spacing={2}>
                <Grid size={3}>
                    <FormControl color="coopinfa" fullWidth>
                        <InputLabel id="proceso-label">Tipo</InputLabel>
                        <Select
                            labelId="categoria-label"
                            size="small"
                            value={proceso}
                            label="Tipo"
                            onChange={(event) => { setProceso(event.target.value) }}
                        >
                            <MenuItem value={1}>{"Mensajes"}</MenuItem>
                            <MenuItem value={2}>{"Likes"}</MenuItem>

                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={3}>
                    <TextField
                        type="date"
                        size="small"
                        fullWidth
                        value={desde}
                        label="Desde"
                        onChange={(event) => { setDesde(event.target.value) }}
                        color="coopinfa"

                    />
                </Grid>
                <Grid size={3}>
                    <TextField
                        type="date"
                        size="small"
                        fullWidth
                        value={hasta}
                        label="Hasta"
                        onChange={(event) => { setHasta(event.target.value) }}
                        color="coopinfa"

                    />
                </Grid>
                <Grid size={3} sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                        control={<Switch size="small" checked={sinResponder}
                            color="coopinfa"
                            onChange={(event) => { setSinResponder(event.target.checked) }} />}
                        label="Sin responder"
                    />
                </Grid>
            </Grid>
        </div>
        <div className={styles.tabla}>
            <div>
                <div className={`${styles.rows} ${styles.head}`}>
                    <div>Fecha</div>
                    <div>Nombre</div>
                    <div>Apellido</div>
                    <div>A qué reaccionó</div>
                    <div>Mensaje</div>
                    <div>Celular</div>
                    <div>Respondido</div>
                </div>
            </div>
            <div className={styles.tabla_div}>
                {
                    rows.map((row) => {
                        return <div className={styles.rows} key={row.id}>
                            <div>{row.fecha}</div>
                            <div>{row.nombre}</div>
                            <div>{row.apellido}</div>
                            <div className={styles.div_play}>
                                <div>
                                    {row.tipo}
                                </div>
                                <div>
                                    <IconButton size="small" onClick={() => {
                                        const tipo = row.tipo == "Item" ? 1 : 2
                                        const id = row.tipo == "Item" ? row.item : row.video
                                        setOpenViewer({
                                            open: true,
                                            id: id,
                                            tipo: tipo
                                        })
                                    }}>
                                        <VisibilityIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <div>
                                {
                                    row.me_gusta ? "(Me Gusta)" : row.mensaje
                                }
                            </div>
                            <div>{row.whatsapp}</div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <FormControlLabel
                                    control={<Switch size="small" checked={row.respondido}
                                        color="coopinfa"
                                        onChange={(event) => { handleRespondido(row.id, event.target.checked) }} />}

                                />
                            </div>
                        </div>
                    })
                }
            </div>
        </div>
    </div>
}